module.exports = __webpack_public_path__ + "c3296c98f89f32a78c3b5531c80f77a6.jpg";